export default {
    LOAD_INSTRUCTOR_COURSE_GROUPS_SUCCESS: 'LOAD_INSTRUCTOR_COURSE_GROUPS_SUCCESS',
    LOAD_INSTRUCTOR_COURSE_GROUPS_FAILURE: 'LOAD_INSTRUCTOR_COURSE_GROUPS_FAILURE',
    ADD_INSTRUCTOR_COURSE_GROUPS_SUCCESS: 'ADD_INSTRUCTOR_COURSE_GROUPS_SUCCESS',
    EDIT_INSTRUCTOR_COURSE_GROUPS_SUCCESS: 'EDIT_INSTRUCTOR_COURSE_GROUPS_SUCCESS',
    DELETE_INSTRUCTOR_COURSE_GROUPS_SUCCESS: 'DELETE_INSTRUCTOR_COURSE_GROUPS_SUCCESS',
    REORDER_INSTRUCTOR_COURSE_GROUPS_SUCCESS: 'REORDER_INSTRUCTOR_COURSE_GROUPS_SUCCESS',
    REORDER_GLOBAL_INSTRUCTOR_COURSE_GROUPS_SUCCESS: 'REORDER_GLOBAL_INSTRUCTOR_COURSE_GROUPS_SUCCESS',
    
    LOAD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS: 'LOAD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS',
    LOAD_INSTRUCTOR_GROUP_CONCEPTS_FAILURE: 'LOAD_INSTRUCTOR_GROUP_CONCEPTS_FAILURE',
    DELETE_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS: 'DELETE_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS',
    ADD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS: 'ADD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS',
    PUBLISH_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS: 'PUBLISH_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS',
    REORDER_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS: 'REORDER_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS',
}
